/* eslint-disable @typescript-eslint/naming-convention */

/**
 * One equipment dispatch bar for the Resource Allocation equipment timeline
 * (GET api/equipment/allocation-gantt). Lean by design - no rates/templates.
 * Dates arrive as ISO strings (or revived Dates depending on the client).
 */
export interface EquipmentAllocationGanttDto {
  EquipmentDispatchID: string;
  EquipmentID: string | null;
  EquipmentKeyID: number;
  EquipmentName: string;
  CategoryName: string | null;
  VPCompanyID: number | null;
  JobID: string;
  VPJobID: string | null;
  JobName: string | null;
  StartDate: string | Date | null;
  EndDate: string | Date | null;
}
